import { Typography } from '@mui/material'
import ReactMarkdown from 'react-markdown'

interface MarkdownProps {
  content: string
  textAlign?: 'left' | 'center' | 'right' | 'justify'
}

export default function Markdown({
  content,
  textAlign = 'left'
}: MarkdownProps): JSX.Element {
  return (
    <div style={{ textAlign }}>
      <ReactMarkdown
        components={{
          p: ({ children }) => (
            <Typography gutterBottom fontWeight={400} component='div'>
              {children}
            </Typography>
          ),
          h1: ({ children }) => (
            <Typography variant='h4' gutterBottom>
              {children}
            </Typography>
          ),
          h2: ({ children }) => (
            <Typography variant='h5' gutterBottom>
              {children}
            </Typography>
          ),
          h3: ({ children }) => (
            <Typography variant='h6' gutterBottom>
              {children}
            </Typography>
          ),
          strong: ({ children }) => (
            <Typography component='span' fontWeight='bold'>
              {children}
            </Typography>
          ),
          em: ({ children }) => (
            <Typography component='span' fontStyle='italic'>
              {children}
            </Typography>
          ),
          a: ({ children, href }) => (
            <Typography
              component='a'
              href={href}
              target='_blank'
              rel='noopener noreferrer'
              sx={{
                textDecoration: 'underline'
              }}
            >
              {children}
            </Typography>
          ),
          ul: ({ children }) => (
            <Typography component='ul' sx={{ pl: 2, mb: 2 }}>
              {children}
            </Typography>
          ),
          ol: ({ children }) => (
            <Typography component='ol' sx={{ pl: 2, mb: 2 }}>
              {children}
            </Typography>
          ),
          li: ({ children }) => (
            <Typography component='li' sx={{ mb: 0.5 }}>
              {children}
            </Typography>
          )
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}
